export class UserScopeEntity {
    userId;
    scopeId;
    roleId;
    role;

    constructor(userId, scopeId, roleId, role = null) {
      this.userId = userId;
      this.scopeId = scopeId;
      this.roleId = roleId;
      this.role = role;
    }
  }
  